import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Image from "next/image";

const ImageLeftFooter = ({
  image,
  children,
  imageWidth = 824,
  imageHeight = 800,
  light = false,
}) => {
  const bgColor = light ? "bg-light-blue" : "bg-dark-blue";

  return (
    <section className="image-left-footer">
      <Row className="position-relative m-0">
        <Col sm={6} className={`${bgColor} p-0`}>
          <div className="image-container p-0 left-0">
            <Image
              src={image}
              width={imageWidth}
              height={imageHeight}
              objectFit="cover"
              unoptimized={true}
            />
          </div>
        </Col>
        <Col
          sm={6}
          className={`${bgColor} ${
            light ? "text-black" : "text-white"
          } content-section ps-4`}>
          {children}
        </Col>
      </Row>
    </section>
  );
};

export default ImageLeftFooter;
